import { Button, Icon } from "./slate-component";
import { useSlateStatic } from "slate-react";

import { insertLink } from "../utils/link";

export default function InsertImageButton() {
  const editor = useSlateStatic();

  const handleInsertLink = () => {
    const url = prompt("Enter a URL");
    insertLink(editor, url);
  };
  return (
    <>
      <Button
        onMouseDown={(event) => {
          event.preventDefault();
          handleInsertLink();
          // if (url && !isImageUrl(url)) {
          //   alert('URL is not an image');
          //   return;
          // }
          // insertImage(editor, url);
        }}
      >
        <Icon>link</Icon>
      </Button>
    </>
  );
}
